var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: true,
        showLimitList: '12,24,36,48'
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'product--sold-out',
    'soldOutLabelHtml': '<div class="product__label label"><p class="product__label-text label__text">' + bcSfFilterConfig.label.sold_out + '</p></div>',
    'saleLabelHtml': '<div class="product__label label"><p class="product__label-text label__text">' + bcSfFilterConfig.label.on_sale + '</p></div>',
    'vendorHtml': '<h4 class="product__vendor h6">{{itemVendorLabel}}</h4>',

    // Grid Template
    'productGridItemHtml':  '<div class="product {{itemRegionUnavailableClass}} {{itemLastClass}} {{itemTextAlignmentClass}} {{itemBorderClass}} three {{itemCycleClass}} {{itemHoverClass}}">' +
                              '{{itemRegionUnavailableBlock}}' +
                              '<div class="product-border relative">' +
                                '{{itemImages}}' +
                                '<div class="product-details">' +
                                  '<div class="product-title"><h5><a href="{{itemUrl}}" title ="{{itemTitle}}">{{itemTitle}}</a>{{itemRegionUnavailableTitle}}</h5></div>' +
                                  '<div class="product-price">{{itemPrice}}</div>' +
                                  '{{itemVendor}}' +
                                '</div>' +
                              '</div>' +
                            '</div>',

    // Pagination Template
    'previousHtml': '<a href="{{itemUrl}}" class="prev"></a><span class="separator" aria-hidden="true"></span>',
    'nextHtml': '<span class="separator" aria-hidden="true"></span><a href="{{itemUrl}}" class="next"></a>',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span class="deco">{{itemTitle}}</span>',
    'paginateHtml': '<div>{{previous}}{{pageItems}}{{next}}</div>',

    // Sorting Template
    'sortingHtml': '<span class="drop-down sort form"><span class="select"><select>{{sortingItems}}</select></span></span>',

    // Show limit Template
    'showLimitHtml': '<span class="form"><h5>' + bcSfFilterConfig.label.show_limit + '{{showLimitItems}}</h5></span>',
};
/************************** BUILD PRODUCT LIST **************************/
var count = 0;

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
     /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
  	data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100;
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add item special Class
    var itemLastClass = (count == bcSfFilterConfig.custom.products_per_page - 1 || count == totalProduct - 1) ? 'last' : '';
    var itemTextAlignmentClass = bcSfFilterConfig.custom.sub_text_alignment;
    var itemBorderClass = bcSfFilterConfig.custom.borders_enable ? 'borders' : '';
    var itemCycleClass = (index == 1 || index % 4 == 1) ? 'first' : '';
    var itemHoverClass = bcSfFilterConfig.custom.quick_collection_hover ? 'hover relative' : '';
    itemHtml = itemHtml.replace(/{{itemLastClass}}/g, itemLastClass);
    itemHtml = itemHtml.replace(/{{itemTextAlignmentClass}}/g, itemTextAlignmentClass);
    itemHtml = itemHtml.replace(/{{itemBorderClass}}/g, itemBorderClass);
    itemHtml = itemHtml.replace(/{{itemCycleClass}}/g, itemCycleClass);
    itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, itemHoverClass);

    // Add item Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

    // Add item Prices
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

    // Add item Vendors
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add item Buttons
    itemHtml = itemHtml.replace(/{{itemButtons}}/g, buildButtons(data));

    // Add region unavailable
    var itemRegionUnavailable = buildRegionUnavailable(data);
    itemHtml = itemHtml.replace(/{{itemRegionUnavailableClass}}/g, itemRegionUnavailable.class);
    itemHtml = itemHtml.replace(/{{itemRegionUnavailableBlock}}/g, itemRegionUnavailable.block);
    itemHtml = itemHtml.replace(/{{itemRegionUnavailableTitle}}/g, itemRegionUnavailable.title);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    count ++;

    return itemHtml;
};

function buildImages(data) {
  var imageHtml = '';
  var size = 360;
  var images = data.images_info;

  if (images.length > 0) {
    var imageId = 'image-' + images[0]['id'] + bcSfFilterConfig.general.template + '-template';
    var lazySize = size / 3 + 'x';
    var imageUrl = bcsffilter.optimizeImage(images[0]['src'], '1x1').replace('_1x1.', '_{width}x.');
    var imageClass = '';
    var imageRatio = images[0]['width'] / images[0]['height'];
    if (imageRatio > 1) {
      imageClass = 'landscape';
    } else if (imageRatio < 1) {
      imageClass = 'vertical';
    } else {
      imageClass = 'square';
    }

    imageHtml += '<div class="product-thumb' + (bcSfFilterConfig.custom.title_align ? ' title-align' : '') + '">';
    imageHtml += '<div class="relative">';
    imageHtml += '<a href="{{itemUrl}}" title="Buy {{itemTitle}}" class="img-align">';
    // Image style
    imageHtml += buildImageStyle(images[0], size);
    imageHtml += '<img id="image-' + imageId + '" class="lazywidth lazyload no-js-hide img-align ' + imageClass + '" ';
    imageHtml += 'src="' + bcsffilter.optimizeImage(images[0]['src'], lazySize) + '" ';
    imageHtml += 'data-src="' + imageUrl + '" ';
    imageHtml += 'data-widths="[200, 220, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900]" ';
    imageHtml += 'data-aspectratio="' + imageRatio + '" data-sizes="auto" ';
    if (bcSfFilterConfig.custom.zoom_enable) {
      imageHtml += 'data-zoom="' + bcsffilter.optimizeImage(images[0]['src'], '1024x1024@2x') + '" ';
    }
    imageHtml += 'alt="{{itemTitle}}">';
    imageHtml += '</a>';
    imageHtml += '{{itemButtons}}';
    imageHtml += '</div>';
    imageHtml += '</div>';
  }

  return imageHtml;
}

function buildImageStyle(image, size) {
  var imageStyle = '';

  var width = size;
  var height = size;
  var aspectRatio = image.width / image.height;
  var smallStyle = true;
  var containerAspectRatio = width * 1.0 / height;

  if (image.aspect_ratio < 1.0) {
    var maximum_width = height * aspectRatio;
    if (image.height <= height) {
      var maximum_height = image.height;
      maximum_width = image.width;
    } else {
      var maximum_height = height;
    }
  } else if (aspectRatio < containerAspectRatio) {
    var maximum_height = height / aspectRatio;
    if (image.height <= height) {
      var maximum_height = image.height;
      var maximum_width = image.width;
    } else {
      var maximum_height = height;
      var maximum_width = height * aspectRatio;
    }
  } else {
    var maximum_height = height / aspectRatio;
    if (image.width <= width) {
      maximum_height = image.height;
      var maximum_width = image.width
      } else {
        var maximum_width = width;
        maximum_height = maximum_width / aspectRatio;
      }
  }

  imageStyle += '<style>';
  if (smallStyle) imageStyle += '@media screen and (min-width: 750px) {';
  imageStyle += '#image-' + image.id + 'collection-template {' +
    'max-width: ' + maximum_width + 'px;' +
    'max-height: ' + maximum_height + 'px;' +
    '}';
  if (smallStyle) imageStyle += '}';

  if (smallStyle) {
    if (aspectRatio < 1) {
      maximum_width = 750 * aspectRatio;
    } else {
      if (image.width < 750) {
        maximum_width = image.width;
      } else {
        maximum_width = 750;
      }
    }
    imageStyle += '@media screen and (max-width: 749px) {'
    imageStyle += '#image-' + image.id + 'collection-template {' +
      'max-width: ' + maximum_width + 'px;' +
      'max-height: 750px;' +
      '}';
    imageStyle += '}';
  }
  imageStyle += '</style>';

  return imageStyle;
}

function buildPrice(data) {
  var priceHtml = '';
  var onSale = data.compare_at_price_min > data.price_min;
  var priceVaries = data.price_min != data.price_max;

  if (data.price_min > 0) {
    if (priceVaries) {
      priceHtml += bcSfFilterConfig.label.from;
    }
    priceHtml += '<h6>' + bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat);
    if (onSale) {
      priceHtml += ' | <del>' + bcsffilter.formatMoney(data.compare_at_price_min, bcsffilter.moneyFormat) + '</del>';
    }
    priceHtml += '</h6>';
  } else {
    if (priceVaries) {
      priceHtml += '<h6>';
      if (data.price_min == 0) {
        priceHtml += bcSfFilterConfig.label.free;
      } else {
        priceHtml += bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat);
      }
      priceHtml += ' - ' + bcsffilter.formatMoney(data.price_max, bcsffilter.moneyFormat) + '</h6>';
    } else {
      priceHtml += '<h6 style="display:none">' + bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat) + '</h6><h6>' + bcSfFilterConfig.label.free + '</h6>';
    }
  }

  return priceHtml;
}

function buildVendor(data) {
  var vendorHtml = '';

  if (bcSfFilterConfig.custom.vendor_enable) {
    vendorHtml += '<p id="product-logistics-{{itemId}}-' + bcSfFilterConfig.general.template + '-template" class="product-logistics ' + (bcSfFilterConfig.custom.quick_collection_hover ? 'no-pad' : '') + '">';
    vendorHtml += '<span class="vendors">';
    vendorHtml += '<a href="' + bcsffilter.buildProductItemVendorUrl(data.vendor) + '">' + data.vendor + '</a>';
    vendorHtml += '</span>';
    vendorHtml += '</p>';
  }

  return vendorHtml;
}

function buildButtons(data) {
  var buttonHtml = '';
  var padClass = bcSfFilterConfig.custom.quick_view_enable && bcSfFilterConfig.custom.quick_collection_hover ? 'no-pad' : '';

  if (bcSfFilterConfig.custom.quick_collection_hover) {
    buttonHtml += '<div class="hover"><div class="hover-body">';
  }

  buttonHtml += '<div class="' + padClass + '">';
  buttonHtml += '<div class="product-variants">';
  buttonHtml += '<div class="purchase-section' + (data.variants.lenght > 1 ? ' multiple' : '') + '">';
  buttonHtml += '<span class="purchase">';
  buttonHtml += '<span class="button-quick"><a href="{{itemUrl}}" title="{{itemTitle}}" class="btn auto-width">' + bcSfFilterConfig.label.details + '</a></span>';
  buttonHtml += '<span class="button-common hidden">';
  if (data.available && data.variants.length > 1) {
    if (bcSfFilterConfig.custom.quick_view_enable) {
      buttonHtml += '<a data-fancybox data-type="ajax" data-src="{{itemUrl}}?view=quick" href="javascript:;" class="quick btn auto-width">' + bcSfFilterConfig.label.quick + '</a>';
    } else {
      buttonHtml += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="btn auto-width" >' + bcSfFilterConfig.label.details + '</a>';
    }
  } else if (data.available && data.variants.length < 2) {
    buttonHtml += '<form id="add-item-form-{{itemId}}-' + bcSfFilterConfig.general.template + '-template" action="/cart/add" method="post" class="' + (bcSfFilterConfig.custom.go_to_cart_enable ? 'go-to-cart' : '') + ' product-form-{{itemId}} variants clearfix">';
    buttonHtml += '<input type="hidden" name="id" value="' + data['variants'][0] + '" aria-hidden="true">';
    buttonHtml += '<input type="submit" id="add-to-cart-{{itemId}}-' + bcSfFilterConfig.general.template + '-template" class="btn auto-width add-to-cart addtocart" name="add" value="' + bcSfFilterConfig.label.add_to_cart + '" />';
    buttonHtml += '</form>';
  } else {
    buttonHtml += '<input type="submit" class="btn outline' + (bcSfFilterConfig.custom.quick_collection_hover ? 'collection-hover' : '') + ' auto-width disabled" disabled="disabled" value="' + bcSfFilterConfig.label.sold_out + '" />';
  }
  buttonHtml += '<span class="cart-animation hidden" aria-hidden="true"></span>';
  buttonHtml += '</span>';
  buttonHtml += '</span>';
  buttonHtml += '</div>';
  buttonHtml += '</div>';
  buttonHtml += '</div>';

  if (bcSfFilterConfig.custom.quick_view_enable && bcSfFilterConfig.custom.quick_collection_hover) {
    buttonHtml += '<div class="button-quick' + padClass + '">';
    if (data.available && data.variants.length > 0) {
      buttonHtml += '<a data-fancybox data-type="ajax" data-src="{{itemUrl}}?view=quick" href="javascript:;" class="quick btn auto-width quick dark">' + bcSfFilterConfig.label.quick + '</a>';
    } else {
      buttonHtml += '<input type="submit" class="btn outline collection-hover auto-width disabled" disabled="disabled" value="' + bcSfFilterConfig.label.sold_out + '" />';
    }
    buttonHtml += '</div>';
  }

  if (bcSfFilterConfig.custom.quick_collection_hover) {
    buttonHtml += '</div></div>';
  }

  return buttonHtml;
}

function buildRegionUnavailable(data){
    var itemRegionUnavailableClass = '';
    var itemRegionUnavailableBlock = '';
    var itemRegionUnavailableTitle = '';
    var isRestricted = data.tags && (data.tags.includes('Cannabis') || data.tags.includes('restricted'));
    if (isRestricted){
        var region = bcSfFilterConfig.custom.selected_province;
        if (!data.tags.includes('available_' + region)){
            itemRegionUnavailableClass = 'region_unavailable';
            itemRegionUnavailableBlock = '<div class="region_unavailable_text region_unavailable_text-product-block">'+ bcSfFilterConfig.label.unavailable_in_your_region +'</div>';
            itemRegionUnavailableTitle = '<span class="region_unavailable_text region_unavailable_text-header">'+ bcSfFilterConfig.label.unavailable_in_your_region +'</span>';
        }
    }
    return {
        class: itemRegionUnavailableClass,
        block: itemRegionUnavailableBlock,
        title: itemRegionUnavailableTitle
    };
}

/************************** END BUILD PRODUCT LIST **************************/

BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Build page items
        var pageItemsHtml = '';
        pageItemsHtml += bcSfFilterConfig.label.current_page;
        pageItemsHtml = pageItemsHtml.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);

        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

/************************** BUILD TOOLBAR **************************/
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');

    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        if (arr[k] == this.queryParams.limit) {
          showLimitItemsHtml += '<a href="' + arr[k] +'" class="active">' + arr[k] + '</a></li>';
        } else {
          showLimitItemsHtml += '<a href="' + arr[k] +'">' + arr[k] + '</a></li>';
        }
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
    }
  }
};
BCSfFilter.prototype.buildShowLimitEvent = function() {
  var _this = this;
  jQ(this.selector.topShowLimit + ' a').click(function(e) {
    onInteractWithToolbar(e, 'limit', _this.queryParams.limit, jQ(this).attr('href'));
  })
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);

      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function (colData, apiData) {
  if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
    var colInfo = colData.collection;

    var breadcrumbHtml = '<span><a href="' + bcSfFilterConfig.shop.url + '" title="' + bcSfFilterConfig.label.back_home_page + '">' + bcSfFilterConfig.label.breadcrumb_home + '</a></span> ';
    breadcrumbHtml += '<span class="separator" aria-hidden="true"></span> ';
    breadcrumbHtml += '<span class="active">{{currentCollectionTitle}}</span> ';
    // Build Tags
    var currentTagsHtml = '';
    if (Array.isArray(bcSfFilterConfig.general.current_tags)) {
      var current_tags = bcSfFilterConfig.general.current_tags;
      for (var k in current_tags) {
        var tag = current_tags[k];
        currentTagsHtml += '<span class="separator" aria-hidden="true"></span>';
        currentTagsHtml += '<span class="active"><a href="/collections/{{currentCollectionLink}}/' + this.slugify(tag) + '" title="' + tag + '" itemprop="item"><span itemprop="name">' + tag + '</span></a></span>';
      }
    }
    breadcrumbHtml += currentTagsHtml;
    // Build Collection Info
    breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollectionLink}}/g, '/collections/' + colInfo.handle).replace(/{{currentCollectionTitle}}/g, colInfo.title);

    jQ('.breadcrumb_text').html(breadcrumbHtml);
  }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data) {
  if (this.isMobile()) {
    jQ('#bc-sf-filter-tree-mobile-button').on('click', function() {
      if (jQ('.bc-sf-filter-tree-mobile-open').length > 0) {
        jQ('#collection-collection-template-filters').css('display', 'none');
      } else {
        jQ('#collection-collection-template-filters').css('display', 'block');
      }
    });
  }
};

BCSfFilter.prototype.buildAll = function(data, isBuildFilterTree, eventType) {
  var self = this;
    // Prepare data
    var paginationSelector = this.selector.pagination;
    var totalProduct = data.total_product;

    if (isBuildFilterTree === true && data.hasOwnProperty('filter')) {
        // Build Filter Tree
        this.buildFilterTree(data.filter.options);
        // Build Filter Selections
        if (this.getSettingValue('general.showRefineBy')) {
            this.buildFilterSelection(data);
        }
        // Customize Filter tree on mobile
        this.buildFilterTreeMobile();
        // Build Filter Tree Button for Mobile
        this.buildFilterTreeMobileButton(data);
        // Build events: clear filter option, clear all filter options and toggle on title
        this.buildAdditionalFilterEvent();
    }
    if (totalProduct > 0) {
        // Build Product List
        this.buildProductList(data.products, eventType);
        // Build Pagination
        var paginationType = this.getSettingValue('general.paginationType');
        if (paginationType == 'default') {
            this.buildPagination(totalProduct);
        } else {
            jQ(paginationSelector).empty();
            if (self.isLoadMorePaginationType()) {
              // Build load more button
              this.buildLoadMoreButton(totalProduct);
              // Build previous button
              this.buildLoadPreviousButton(totalProduct, eventType);
            }
        }
        // Build Toolbar
        this.buildToolbar();
        // Build Toolbar Event (Pagination, Sorting,...)
        this.buildToolbarEvent(data);
        // Hide Error Notification after build succesfully
        jQ(this.selector.filterWrapper).show();
        var topNotificationSelector = this.selector.topNotification;
        if (jQ(topNotificationSelector).length > 0) jQ(topNotificationSelector).empty();
    }

    // Show Products & Pagination after building (also used for Fallback)
    jQ(this.selector.products).removeAttr('data-bc-sort');
    jQ(paginationSelector).show();

    // Build Additional Elements
    this.buildAdditionalElements(data, eventType);

    // Build Scroll to Top
    this.buildScrollToTop();

    // Build Page information
    this.buildPageInfo(data);

    // Build Search
    if (this.isSearchPage()) {
        this.buildSearchResultHeader(data);
        this.buildSearchResultNumber(data);
    }

    // Add Meta tag to exclude pages with filter params from Goolge crawl
    this.buildRobotsMetaTag(data);

    this.selectFilter = false;
};
